exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".BadgeClassesList__name-col___1bz1R {\n  max-width: 300px; }\n\n.BadgeClassesList__list-badges-container___14kXI a {\n  color: #000; }\n", "", {"version":3,"sources":["/app/client/src/components/Frontend/BadgeClassesList/BadgeClassesList.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAAE;;AAErB;EACE,YAAY,EAAE","file":"BadgeClassesList.scss","sourcesContent":[".name-col {\n  max-width: 300px; }\n\n.list-badges-container a {\n  color: #000; }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"name-col": "BadgeClassesList__name-col___1bz1R",
	"list-badges-container": "BadgeClassesList__list-badges-container___14kXI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/components/Frontend/BadgeClassesList/BadgeClassesList.scss
// module id = 247
// module chunks = 0